export default __webpack_public_path__ + "static/media/my-job-is-done-here.e6aa28a4.gif";